
import { Component, Vue } from 'vue-property-decorator';
import { getBusinessStoreEventList, deleteBusinessStoreEvent } from '@/api/businessStoreEvent';
import Pagination from '@/components/Pagination/index.vue';
import EventForm from './components/form.vue';

@Component({
  components: {
    Pagination,
    EventForm,
  },
})
export default class extends Vue {
  mounted() {
    this.getList();
  }

  private loading = true;

  private listQuery = {
    page: 0,
    size: 10,
    searchValue: '',
  }

  private dateRange = [];

  private totalElements = 0;

  private eventList = [];

  private formVisible = false;

  private formIdx = null;

  private getList() {
    this.loading = true;
    getBusinessStoreEventList(this.listQuery).then((res) => {
      this.totalElements = res.data.totalElements;
      this.eventList = res.data.content;
      this.loading = false;
    });
  }

  private handleDelete(item: any) {
    this.$confirm('정말 이벤트를 삭제하시겠습니까?', '이벤트 삭제', {
      confirmButtonText: '예',
      cancelButtonText: '아니오',
      type: 'error',
    }).then(() => {
      deleteBusinessStoreEvent(item.idx).then(() => {
        this.$message.success('이벤트를 삭제했습니다.');
        this.getList();
      });
    });
  }

  private handleSearch() {
    this.listQuery.page = 0;
    this.getList();
  }

  private handleVisibleForm(idx: any) {
    this.formIdx = idx;
    this.formVisible = !this.formVisible;
  }

  private handleSave() {
    this.handleVisibleForm(null);
    this.getList();
  }

  private getNumber(index: number) {
    let totalSize = (this.listQuery.page - 1) * this.listQuery.size;
    if (totalSize < 0) totalSize = 0;
    return this.totalElements - totalSize - index;
  }
}
